import { render, staticRenderFns } from "./ArticlesMergeDialog.vue?vue&type=template&id=7f31120f&"
import script from "./ArticlesMergeDialog.vue?vue&type=script&lang=ts&"
export * from "./ArticlesMergeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlesMergeDialog.vue?vue&type=style&index=0&id=7f31120f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports